module.exports = __webpack_public_path__ + "img/homepage-banners-mazda-compliant-mitsu.e0d673de.jpg";